import styled from 'styled-components';
import {mobileMedia, DARK_GRAY, GRAY3} from '../../globalVariables/GlobalVariables';
import {dFlex, dFlexColumn, justifyCenter, flexColumn} from '../../globalVariables/GlobalFlex';
import {right as PWRight} from '../components/pageWrapper/PageWrapper.css';

const HEADER_HEIGHT = '120px';

export const container = styled.div`
    height: 100%;
    
    ${PWRight} {
        ${mobileMedia} {
            padding-inline: 10px;
        }
    }
`;

export const main = styled.div`
    height: calc(100% - 90px);
    ${dFlex};
    max-width: 1150px;
    margin: 0 auto;
    
    ${mobileMedia} {
        max-width: 400px;
        ${flexColumn};
    }
`;

export const leftContainer = styled.div`
    flex-grow: 2;
    padding-inline: 1vw;
    flex-basis: 100%;
    ${dFlexColumn};
    
    ${mobileMedia} {
        min-width: unset;
        padding-inline: 0;
    }
`;

export const header = styled.div`
    height: ${HEADER_HEIGHT};
    ${dFlexColumn};
    ${justifyCenter};
    margin-bottom: 20px;
    
    ${mobileMedia} {
        height: auto;
        margin-bottom: 15px;
    }
`;

export const title = styled.h1`
    font-weight: 600;
    font-size: 24px;
    color: ${DARK_GRAY};
    margin: 0 0 8px 0;
    
    ${mobileMedia} {
        font-size: 20px;
    }
`;

export const subtitle = styled.p`
    font-size: 14px;
    color: ${GRAY3};
    margin: 0;
    
    ${mobileMedia} {
        font-size: 13px;
    }
`;
